import Axios from "@app/api/axios";
const fetchOrdersForInvoiceReport = (params = "") =>
  Axios.get(`orders/invoice-report${params}`);

export default fetchOrdersForInvoiceReport;
